import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';

export default class ApiRequestState extends AbstractSubject {
    public static REQUESTING = 'requesting';

    public static REQUEST_SUCCESS = 'request_success';

    public static REQUEST_FAILED = 'request_failed';

    static readonly #allowedStates = [
        ApiRequestState.REQUESTING,
        ApiRequestState.REQUEST_SUCCESS,
        ApiRequestState.REQUEST_FAILED
    ];

    static #instance: ApiRequestState | null = null;

    #state = '';

    public static getInstance(): ApiRequestState {
        if (ApiRequestState.#instance === null) {
            ApiRequestState.#instance = new ApiRequestState();
        }

        return ApiRequestState.#instance;
    }

    public set state(state: string) {
        if (!ApiRequestState.#allowedStates.includes(state)) {
            return;
        }

        this.#state = state;
        this.notify();
    }

    public get state(): string {
        return this.#state;
    }
}
